import { BsTelephone } from "react-icons/bs";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TiMail } from "react-icons/ti";
import { useNavigate } from "react-router-dom";

type Props = {};

const Footer = (props: Props) => {
  const navigate = useNavigate();

  return (
    <div>
      <div
          className="lg:py-8 py-4 w-full "
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            backgroundColor: " #ED1C24",
          }}
        >
          <div className="w-full lg:flex md:flex flex-row justify-center">
              <div className="flex flex-row justify-center text-white text-sm">
                    {" "}
                    All rights reserved © {new Date().getFullYear()} - carrental
                  </div>
                {/**<div className="flex flex-row gap-2 ">
                  <a
                    href="mailto:contact@carrental.app"
                    className="text-lg font-normal text-center text-white"
                  >
                    <TiMail className="h-6 w-6"/>
                  </a>
                  <a
                    href="mailto:contact@carrental.app"
                    className="text-sm text-white font-normal"
                  >
                    contact@carrental.app
                  </a>
                </div>
                <div className="flex flex-row gap-2">
                  <a
                    href="tel:+833-799-7770"
                    className="text-lg font-normal  text-center text-white"
                  >
                    <BsTelephone className="h-6 w-6" />
                  </a>
                  <a
                    href="tel:+833-799-7770"
                    className="text-sm text-white font-normal"
                  >
                    (020) 4131 2229
                  </a>
                </div>
                <div className="flex flex-row gap-2 ">
                  <div className="text-lg font-normal  text-center text-white">
                    <HiOutlineLocationMarker className="text-white h-6 w-6" />
                  </div>
                  <a
                    href="https://www.google.com/maps/place/Panchshil+Futura/@18.5203484,73.9296349,17z/data=!3m2!4b1!5s0x3bc2c0896211a525:0x14279027d7af3922!4m6!3m5!1s0x3bc2c1896afb8635:0x4698a0d309eaa87a!8m2!3d18.5203433!4d73.9322098!16s%2Fg%2F11hd24v0lz?entry=ttu"
                    className="text-sm text-white font-normal"
                  >
                    Panchshil Futura, Sr No 133(P), CTS No 4944, Magarpatta, Hadapsar, Pune, Maharashtra 411028
                  </a>
                </div> */}
              </div>
        </div>
       {/**  <div
            className="lg:py-8 py-4 h-[200px] md:h-[80px] w-full "
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <div className="w-full lg:flex md:flex  flex-row">
              <div className="lg:w-full w-[95%] lg:ml-[3.5rem] xl:ml-[7.5rem] ml-[20px]  lg:flex  md:flex-row flex-col md:ml-36 xl:gap-[500px] lg:gap-[300px] text-slate-500 font-normal text-sm">
                <div className="flex md:flex-row flex-col gap-2">
                  <div className="flex flex-row text-[17px]">
                    {" "}
                    All rights reserved © {new Date().getFullYear()} - carrental
                  </div>
                   <div
                    className="flex flex-row cursor-pointer text-[17px]"
                    onClick={() => {
                      navigate("/privacy-policy");
                    }}
                  >
                    <span>|</span>
                    <span className="ml-1">Privacy Policy</span>
                     
                  </div>
                  <div
                    className="flex flex-row cursor-pointer text-[17px]"
                    onClick={() => {
                      navigate("/terms-and-condition");
                    }}
                  >
                    <span>|</span>
                    <span className="ml-1">Terms & Conditions</span>
                     
                  </div>
                  <div
                    className="flex flex-row cursor-pointer text-[17px]"
                    onClick={() => {
                      navigate("/contact-us");
                      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                    }}
                  >
                    <span>|</span>
                    <span className="ml-1">Contact Us</span>
                    
                  </div>
                </div>
                <div className="flex flex-row lg:gap-5 gap-4 lg:mt-0 lg:mr-3 xl-mr-0 mt-2 ">
                  <div className="flex flex-row">
                    <a href="https://www.facebook.com/profile.php?id=100094694231062&mibextid=ZbWKwL">
                      <FaFacebook className="w-5 h-5" />
                    </a>
                  </div>
                  <div className="flex flex-row">
                    <a href="https://www.linkedin.com/company/spotfinder-app/">
                      <FaLinkedin className="w-5 h-5" />
                    </a>
                  </div>
                  <div className="flex flex-row ">
                    <a href="https://instagram.com/spotfinder.in?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D">
                      <FaInstagram className="w-5 h-5" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
    </div>
    
  );
};

export default Footer;
